module.exports = __webpack_public_path__ + "img/connect-2-m.5c7fff02.png";